import {Button, Card, Form, Input, Modal} from 'antd';
import {jwtDecode} from 'jwt-decode';
import {useEffect, useState} from 'react';
import toast from 'react-hot-toast';
import {useDispatch} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';

import bgImage from '../../assets/Images/GoldChains1.png';
import {RQUserLoginAPI} from '../../reactQuery/apis';
import {loginSuccess} from '../../redux/authAction';

import {ForgotPasswordScreen} from './ForgetPasswordScreen';
import {RegistrationScreen} from './RegistrationScreen';

const LoginScreen = () => {
  const [form] = Form.useForm();

  const location = useLocation();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(true);

  const [showRegister, setShowRegister] = useState(false);

  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const from = location.state?.from || '/';

  useEffect(() => {
    if (location.pathname !== '/auth/login') {
      setIsModalOpen(false);
    }
  }, [location]);

  const {mutate: loginUser, isLoading} = RQUserLoginAPI({
    onSuccess: response => {
      if (response?.token) {
        const decodedToken = jwtDecode(response.token);
        const userRole = decodedToken?.role;
        dispatch(loginSuccess({...response, role: userRole}));

        if (userRole === 'ADMIN') {
          toast.success('Admin logged in successfully!');
          navigate('/dashboard');
        } else if (userRole === 'USER') {
          toast.success('User logged in successfully!');
          navigate(from, {replace: true});
        }
      } else {
        toast.error(response?.message || 'Access denied.');
      }
    },
    onError: error => {
      toast.error(error?.response.data.message || 'Invalid username or password');
    },
  });

  const onSubmit = data => {
    loginUser(data);
  };

  const onClose = () =>{
    setIsModalOpen(false);
    navigate('/');
  };

  return (
    <div
      className={'h-screen w-screen bg-cover bg-center'}
      style={{backgroundImage: `url(${bgImage})`}}
    >
      <Modal
        centered={true}
        title={showRegister ? 'Register' : showForgotPassword  ? 'Forgot Password' : 'Login' }
        visible={isModalOpen}
        footer={false}
        closable={true}
        onCancel={onClose}
        maskClosable={false}
        width={600}
        className={'overflow-y-auto h-2/3  max-h-[500px] rounded-lg'}
      >
        {showRegister ? (
          <RegistrationScreen setShowRegister={setShowRegister} setShowForgotPassword={setShowForgotPassword} />
        ) : showForgotPassword ? (
          <ForgotPasswordScreen setShowForgotPassword={setShowForgotPassword} />
        ) : (
          <Card className={' border-none'}>
            <Form
              form={form}
              layout={'vertical'}
              onFinish={onSubmit}  
            >
              <Form.Item
                label={'Email'}
                name={'email'}
                rules={[
                  {required: true, message: 'Email is required'},
                  {type: 'email', message: 'Invalid email format'},
                ]}
              >
                <Input placeholder={'Enter your email'} />
              </Form.Item>

              {/* Password */}
              <div className={''}>
                <Form.Item
                  label={'Password'}
                  name={'password'}
                  style={{marginBottom: 0}}
                  rules={[
                    {required: true, message: 'Password is required'},
                    {min: 6, message: 'Password must be at least 6 characters'},
                  ]}
                >
                  <Input.Password placeholder={'Enter your password'} />
                </Form.Item>
                <div className={'flex w-full justify-end items-center mb-4'}>
                  <Button
                    onClick={() => {
                      setShowForgotPassword(true);
                      setShowRegister(false);
                      form.resetFields();
                    }}
                    className={'!text-primary-900 bg-transparent border-none cursor-pointer'}
                  >
                Forgot Password
                  </Button>
                </div>
              </div>

              {/* Login Button */}
              <Form.Item>
                <Button
                  htmlType={'submit'}
                  className={'w-full !bg-[#3d180f] !text-white'}
                >
                  {isLoading ? 'Logging in...' : 'Login'}
                </Button>
              </Form.Item>

              {/* Register Button */}
              <Form.Item>
                <Button
                  className={'w-full !text-primary-900 border-none'}
                  onClick={() => {
                    form.resetFields(); 
                    setShowRegister(true);
                  }}
                >
               Don&apos;t have an account? Register
                </Button> 
               
              </Form.Item>
            </Form>
          </Card>
        )}
      </Modal>
    </div>
  );
};

export default LoginScreen;
